import navigator from './navigator'
import axios from 'axios'
import stepText from './stepText'
import OpenSeadragon from 'openseadragon'
import client from './client'
import screenfull from 'screenfull'
import ganalytics from './ganalytics'
import stepList from './stepList'
import { AssetsService } from '@coosmo/shared-utils'

let lastInteractionTime = 0
let inTransition = false

export function setFullscreenIcon(toggleFullScreenImageTag, fullScreenExitIcon, fullScreenIcon) {
  toggleFullScreenImageTag.src = screenfull.isFullscreen ? fullScreenExitIcon : fullScreenIcon
}

export function setupGoogleAnalytics(storyboard) {
  ganalytics.attachAnalyticsToOpenseaDragon(storyboard.viewer, storyboard.metadata, storyboard.metadata.customerCode)
  ganalytics.attachAnalyticsToCustomButton(
    document.getElementById('toggleChaptersList'),
    'step-list',
    storyboard.metadata,
    storyboard.metadata.customerCode
  )
  ganalytics.attachAnalyticsToCustomButton(
    document.getElementById('prevStep'),
    'prev-step',
    storyboard.metadata,
    storyboard.metadata.customerCode
  )
  ganalytics.attachAnalyticsToCustomButton(
    document.getElementById('nextStep'),
    'next-step',
    storyboard.metadata,
    storyboard.metadata.customerCode
  )
  ganalytics.attachAnalyticsToCustomButton(
    document.getElementById('zoom-out'),
    'zoom',
    storyboard.metadata,
    storyboard.metadata.customerCode
  )
  ganalytics.attachAnalyticsToCustomButton(
    document.getElementById('zoom-in'),
    'zoom',
    storyboard.metadata,
    storyboard.metadata.customerCode
  )
}

export function init(storyboardID, storyboard, navigatorWidth = '184px', navigatorHeight = '184px') {
  navigator.clear()

  const endpoint = `${process.env.API_BASE_URL}meta/iiif/${storyboardID}/manifest`

  axios.get(endpoint).then(function (response) {
    storyboard.DOM.storyTitle.textContent = response.data.label
    storyboard.containers.annotations = []
    storyboard.containers.promises = []
    storyboard.viewerOptions.tileSources = []
    storyboard.containers.canvases = response.data.sequences[0].canvases
    storyboard.stepper.currentAnimationStep = -1
    storyboard.stepper.totalAnimationSteps = null
    storyboard.stepper.currentGlobalAnimationStep = 0

    storyboard.metadata.title = response.data.label
    storyboard.metadata.uuid = storyboardID
    storyboard.metadata.author = 'haltadefinizione'

    stepText.hideStepContent(storyboard)

    let annotation
    storyboard.containers.canvases.forEach(function (canvas) {
      const metadata = canvas.metadata || []
      annotation = {
        title: metadata[0] ? metadata[0].value : '---',
        author: metadata[1] ? metadata[1].value : '---',
        date: metadata[2] ? metadata[2].value : '---',
        technique: metadata[3] ? metadata[3].value : '---',
        dimensions: metadata[4] ? metadata[4].value : '---',
        place: metadata[5] ? metadata[5].value : '---',
        city: metadata[6] ? metadata[6].value : '---',
        width: canvas.width,
        height: canvas.height
      }

      storyboard.viewerOptions.tileSources.push(canvas.images[0].resource.service['@id'])
      storyboard.containers.annotations.push(annotation)

      if (canvas.otherContent && canvas.otherContent.length > 0) {
        var annotationsEndpoint = canvas.otherContent[0]['@id']

        storyboard.containers.promises.push(axios.get(annotationsEndpoint))
      } else {
        storyboard.containers.promises.push(
          new Promise(function (resolve, reject) {
            resolve({})
          })
        )
      }
    })

    Promise.all(storyboard.containers.promises).then(function (values) {
      storyboard.viewerOptions.navigatorHeight = navigatorHeight
      storyboard.viewerOptions.navigatorWidth = navigatorWidth
      storyboard.viewer = OpenSeadragon(storyboard.viewerOptions)
      storyboard.viewer.addHandler('tile-loaded', function (e) {
        storyboard.DOM.spinnerContainer.classList.add('hidden')
      })
      storyboard.viewer.addHandler('animation-finish', storyboard.onAnimationFinish)
      storyboard.viewer.addHandler('open', function () {
        storyboard.stepper.totalAnimationSteps = 0

        client
          .getMetaDataForStories(
            `${process.env.API_BASE_URL}meta/images/search/findByUuid?uuid=`,
            storyboard.containers.promises,
            0
          )
          .then(response => {
            storyboard.viewer.viewport.maxZoomPixelRatio = response
            storyboard.viewer.viewport.applyConstraints()
          })

        values.forEach(function (annotations, i) {
          let steps = []

          if (annotations.data.resources) {
            annotations.data.resources.forEach(function (annotation, j) {
              let annotationText
              annotation.resource.forEach(function (resource) {
                if (resource['@type'] === 'dctypes:Text') {
                  annotationText = resource.chars
                }
              })

              storyboard.stepper.totalAnimationSteps++

              const rectString = annotation.on[0].selector.default.value
              const rectStringsArray = rectString.replace('xywh=', '').split(',')

              const x = parseFloat(rectStringsArray[0])
              const y = parseFloat(rectStringsArray[1])
              const w = parseFloat(rectStringsArray[2])
              const h = parseFloat(rectStringsArray[3])

              steps.push({
                duration: annotation.transition.duration,
                delay: annotation.transition.delay,
                rect: storyboard.viewer.viewport.imageToViewportRectangle(x, y, w, h),
                label: annotation.label,
                caption: annotationText,
                image: i,
                stepIndex: j,
                stepNumber: storyboard.stepper.totalAnimationSteps,
                thumbnail: annotation.links.annotatedRegion
              })
            })
          }

          storyboard.containers.annotations[i].steps = steps
        })

        stepList.build(storyboard)

        if (storyboard.firstLaunch) {
          storyboard.nextStep(() => {
            storyboard.firstLaunch = false
          })
        }
      })

      navigator.setup(storyboard)
      const fullScreenIcon = AssetsService.getSvgIcon('full-screen.svg')
      const fullScreenExitIcon = AssetsService.getSvgIcon('full-screen-exit.svg')

      let toggleFullScreenImageTag = document.getElementById('fullScreen')
      toggleFullScreenImageTag.src = fullScreenIcon

      setFullscreenIcon(toggleFullScreenImageTag, fullScreenExitIcon, fullScreenIcon)

      screenfull.on('change', () => {
        setFullscreenIcon(toggleFullScreenImageTag, fullScreenExitIcon, fullScreenIcon)
      })

      setupGoogleAnalytics(storyboard)

      const urlParams = new URLSearchParams(window.location.search)
      const autoplay = urlParams.get('autoplay') ? true : false
      if (autoplay) {
        // Track the last time the user did something
        lastInteractionTime = Date.now()

        // Whenever the user does something, reset the timer
        ;['click', 'mousemove', 'keydown', 'touchstart'].forEach(eventName => {
          document.addEventListener(eventName, () => {
            lastInteractionTime = Date.now()
          })
        })

        // Now periodically check how long its been since last interaction
        setInterval(() => {
          const now = Date.now()
          const timeSinceLastInteraction = now - lastInteractionTime
          // Only go to next step if:
          // 30s have passed and we are not already in a transition
          if (!inTransition && timeSinceLastInteraction >= 30000) {
            storyboard.nextStep()
            inTransition = true
          }
        }, 1000)
      }
    })
  })
}

export function resetAutoplayTimer() {
  lastInteractionTime = Date.now()
}

export function setTransitionActive(isActive) {
  inTransition = isActive
}

export default { init, resetAutoplayTimer, setTransitionActive }
